export default __webpack_public_path__ + "static/wales-161e7a1fc57d3b3c2323c839124d9f14.png";